export default __webpack_public_path__ + "ce713a2912228f0aa692015a27f23af4.png";